export const XrSessionTypes = {
  HmdVR: 0, // Head-mounted display (HMD), two-camera virtual reality session
  MobileAR: 1, // Mobile device, single-camera augmented reality session
  LookingGlassVR: 2, // Looking Glass hologram display, N-camera virtual reality session
  HmdAR: 3,
};

export default {
  XrSessionTypes,
};
